<mat-toolbar color="accent">Enrol from Custom Report</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <pr-campaign-report-summary [customReport]="data.customReport" />

    @if (
      datePickers.dateFilters().length || datePickers.dateRangeFilters().length
    ) {
      <div class="flex flex-col gap-2">
        <h3 class="!m-0 !font-bold">Select date range</h3>
        <div class="flex flex-row gap-4" [formGroup]="datePickers.formGroup">
          @if (datePickers.dateFilters().length > 0) {
            <mat-form-field subscriptSizing="dynamic">
              <mat-label>Select Date</mat-label>
              <input matInput formControlName="date" [matDatepicker]="picker" />
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-datepicker #picker />
            </mat-form-field>
          }

          @if (datePickers.dateRangeFilters().length > 0) {
            <pt-date-range-form
              dateLabel="Select Date Range"
              [useRangePicker]="true"
              [from]="datePickers.formGroup.value.dateFrom"
              [to]="datePickers.formGroup.value.dateTo"
              (changed)="datePickers.setDateRange($event)"
            />
          }
        </div>
      </div>
    }

    <div class="flex flex-col gap-2">
      <h3 class="!m-0 !font-bold">Enrolment Estimates</h3>
      @if (loading$ | async) {
        <div class="flex flex-col items-center justify-center gap-4">
          <mat-spinner [diameter]="32" />
          <div class="text-xs opacity-50">
            Loading entries from the report, please wait...
          </div>
        </div>
      } @else {
        @if (enrolment$ | async; as enrolment) {
          <pr-campaign-run-enrolment-estimates [enrolment]="enrolment" />
        } @else {
          <pr-information-box theme="warn">
            @if (errorMessage$ | async; as errorMessage) {
              <p class="!m-0 font-bold">Error loading file</p>
              <p class="!m-0">{{ errorMessage }}</p>
            } @else {
              Something went wrong while processing the report. Please try
              again.
            }
          </pr-information-box>
        }
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="(isDisabled$ | async) || (loading$ | async)"
      (click)="submit()"
    >
      Preview Entries
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
